import { Routes, Route, Outlet, useLocation } from "react-router-dom";
import RequireAdmin from "./RequireAdmin";
import ContentPreview from "./content/ContentPreview";
import AdminWorkspace from "pages/admin/AdminWorkspace";
import AdminInvitationPage from "pages/admin/AdminInvitationPage";
import AdminLoginPage from "pages/admin/AdminLoginPage";
import CustomerAccessPage from "pages/CustomerAccessPage";
import SeoRouteMetadata from "components/SeoRouteMetadata";

// One persistent permission boundary for every protected admin URL. Only public
// pages use App's pathname-keyed animation; login/invitation remain unguarded.
export default function AdminLayoutBoundary({ children }) {
  const { pathname } = useLocation();
  if (pathname === '/customer/access' || pathname.startsWith('/customer/access/'))
    return <><SeoRouteMetadata /><Routes><Route path="/customer/access/*" element={<CustomerAccessPage />} /></Routes></>;
  if (pathname !== '/admin' && !pathname.startsWith('/admin/')) return children;
  return <><SeoRouteMetadata /><Routes>
    <Route path="/admin/invitation" element={<AdminInvitationPage />} />
    <Route path="/admin/login" element={<AdminLoginPage />} />
    <Route element={<RequireAdmin><Outlet /></RequireAdmin>}>
      <Route path="/admin/services" element={<AdminWorkspace />} />
      <Route path="/admin" element={<AdminWorkspace />} />
      <Route path="/admin/blogs" element={<AdminWorkspace />} />
      <Route path="/admin/blogs/new" element={<AdminWorkspace />} />
      <Route path="/admin/blogs/:id/edit" element={<AdminWorkspace />} />
      <Route path="/admin/webinars" element={<AdminWorkspace />} />
      <Route path="/admin/services/new" element={<AdminWorkspace />} />
      <Route path="/admin/services/:id/edit" element={<AdminWorkspace />} />
      <Route path="/admin/resources" element={<AdminWorkspace />} />
      <Route path="/admin/resources/new" element={<AdminWorkspace />} />
      <Route path="/admin/resources/:id/edit" element={<AdminWorkspace />} />
      <Route path="/admin/site-content" element={<AdminWorkspace />} />
      <Route path="/admin/media" element={<AdminWorkspace />} />
      <Route path="/admin/:domain/:id/preview" element={<ContentPreview />} />
      <Route path="/admin/*" element={<AdminWorkspace />} />
    </Route>
  </Routes></>;
}
